// @flow
import { TRIPADVISOR_TESTIMONY } from 'Client/cms/toolkit/constants';
import { TripadvisorTestimonyLine } from 'Components/lines/tripadvisor-testimony-line/TripadvisorTestimonyLine';

export type CMSProps = {
  id: string,
  text: string,
  stars: string,
  onBy: string,
  author: string,
  date: string,
  fullCommentLink: string,
  link: CMSLink,
};

export const tripadvisorTestimonyDescriptor = {
  name: TRIPADVISOR_TESTIMONY,
  component: TripadvisorTestimonyLine,
};
